import { FunnelConfigResponseDTO, LiheContentResponseDTO, PriceResponseDTO, QuoteResponseDTO, ServiceContentResponseDTO, ServiceFamiliesResponseDTO } from "@requests"

export interface IAPIResponses {
    funnelConfig: FunnelConfigResponseDTO | null
    priceResponse: PriceResponseDTO | null
    bookingQuoteResponse: QuoteResponseDTO | null
    serviceFamiliesContentResponse: ServiceFamiliesResponseDTO | null
    serviceContentResponses: ServiceContentResponseDTO
    liheContentResponse: LiheContentResponseDTO | null
}

export default class APIResponses implements IAPIResponses {
    public funnelConfig: FunnelConfigResponseDTO | null
    public priceResponse: PriceResponseDTO | null
    public bookingQuoteResponse: QuoteResponseDTO | null
    public serviceFamiliesContentResponse: ServiceFamiliesResponseDTO | null
    public serviceContentResponses: ServiceContentResponseDTO
    public liheContentResponse: LiheContentResponseDTO | null
    constructor(
        funnelConfig: FunnelConfigResponseDTO | null,
        priceResponse: PriceResponseDTO | null,
        bookingQuoteResponse: QuoteResponseDTO | null,
        serviceFamiliesContentResponse: ServiceFamiliesResponseDTO | null,
        serviceContentResponses: ServiceContentResponseDTO,
        liheContentResponse: LiheContentResponseDTO | null,
    ) {
        this.funnelConfig = funnelConfig
        this.priceResponse = priceResponse
        this.bookingQuoteResponse = bookingQuoteResponse
        this.serviceFamiliesContentResponse = serviceFamiliesContentResponse
        this.serviceContentResponses = serviceContentResponses
        this.liheContentResponse = liheContentResponse
    }
}